import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import Title, { SubTitle } from "../Components/Utils";
import { useNavigate } from "react-router-dom";
// import ReCAPTCHA from "react-google-recaptcha";
import { CUSTOMERID, REGISTER_USER, TOKEN } from "../CONSTANTS";
import { Loader } from "../Components/Loader";
import toast from "react-hot-toast";
import { useScreenSize, useCustomScreen } from "../../src/Components/Utils";
import ReCAPTCHA from "react-google-recaptcha";
import validator from "validator";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Signup = () => {
  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState("+1 (US)");
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [validation, setValidation] = useState(false);
  const [errors, setErrors] = useState({});
 

  const states = [
    "Alabama",
    "Alaska",
    "Alberta",
    "Arizona",
    "Arkansas",
    "British Columbia",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "District Of Columbia",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Labrador",
    "Louisiana",
    "Maine",
    "Manitoba",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Brunswick",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "Newfoundland",
    "North Carolina",
    "North Dakota",
    "North West Terr.",
    "Nova Scotia",
    "Nunavut",
    "Ohio",
    "Oklahoma",
    "Ontario",
    "Oregon",
    "Pennsylvania",
    "Prince Edward Is.",
    "Quebec",
    "Rhode Island",
    "Saskatchewan",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
    "Yukon",
    "New South Wales",
    "Victoria",
    "Queensland", 
    "Western Australia",
    "South Australia",
    "Tasmania",
    "Northern Territory",
    "Australian Capital Territory",
  ];

  const onChange = async (value) => {
    setRecaptchaValue(value);
  };

  const emailChangeHandler = (e) => {
    const { name, value } = e.target;
    setEmail(e.target.value);

    if (value === "") {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else if (!validator.isEmail(value)) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Please enter a valid email address",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const passwordChangeHandler = (e) => {
    const { name, value } = e.target;
    setPassword(e.target.value);
    if (value === "") {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else if (!validator.isStrongPassword(value)) {
      setErrors((prev) => ({
        ...prev,
        [name]:
          "Password should contain a combination of Captial letter, small letter, number and a special character",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const confirmPasswordHandler = (e) => {
    const { name, value } = e.target;
    setConfirmPassword(value);
    if (value === "") {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else if (value.trim() !== password.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Passwords do not match",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const firstNameChangeHandler = (e) => {
    const { name, value } = e.target;
    const cleanedFirstName = value.replace(/[^A-Za-z]/g, "");
    setFirstName(cleanedFirstName);
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else if (e.target.value.replace(/[^0-9]/g, "")) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const lastNameChangeHandler = (e) => {
    const { name, value } = e.target;
    const cleanedLastName = value.replace(/[^A-Za-z]/g, "");
    setLastName(cleanedLastName);
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else if (e.target.value.replace(/[^0-9]/g, "")) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const companyNameChangeHandler = (e) => {
    const { name, value } = e.target;
    setCompanyName(e.target.value);
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

//  const phoneNumberChangeHandler = (e) => {
//   const { name, value } = e.target;

//   let cleaned = value.replace(/[^0-9+\-\(\) ]/g, "");

//   let digitsOnly = cleaned.replace(/[^0-9]/g, "");

//   if (!digitsOnly) {
//     cleaned = "";
//   } else if (!cleaned.startsWith("+")) {
//     if (digitsOnly.length <= 10) {
//       let formatted = "";
//       if (digitsOnly.length > 0) formatted += "(" + digitsOnly.substring(0, 3);
//       if (digitsOnly.length >= 4) formatted += ") " + digitsOnly.substring(3, 6);
//       if (digitsOnly.length >= 7) formatted += "-" + digitsOnly.substring(6, 10);
//       cleaned = formatted;
//     } else {
//       cleaned = digitsOnly;
//     }
//   }

//   setPhoneNumber(cleaned);

//   if (!digitsOnly.trim()) {
//     setErrors((prev) => ({
//       ...prev,
//       [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
//     }));
//   } else if (digitsOnly.length !== 10 && !cleaned.startsWith("+")) {
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "Phone number must be 10 digits",
//     }));
//   } else if (cleaned.startsWith("+") && (digitsOnly.length < 9 || digitsOnly.length > 13)) {
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "Invalid international phone number",
//     }));
//   } else {
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   }
// };

const phoneNumberChangeHandler = (e) => {
  const { name, value } = e.target;

  let cleaned = value.replace(/[^0-9]/g, "");
  let formatted = "";

  // 🇺🇸 🇨🇦 US / Canada
  if (countryCode === "+1 (US)" || countryCode === "+1 (CA)") {
    if (cleaned.length > 0) formatted += "(" + cleaned.substring(0, 3);
    if (cleaned.length >= 4) formatted += ") " + cleaned.substring(3, 6);
    if (cleaned.length >= 7) formatted += "-" + cleaned.substring(6, 10);
    formatted = formatted.substring(0, 14);
  }

  // 🇦🇺 Australia
  if (countryCode === "+61 (AU)") {
    if (cleaned.length > 0) formatted += cleaned.substring(0, 4);
    if (cleaned.length >= 5) formatted += " " + cleaned.substring(4, 7);
    if (cleaned.length >= 8) formatted += " " + cleaned.substring(7, 10);
    formatted = formatted.substring(0, 12);
  }

  setPhoneNumber(formatted);

  // ---------- Validation ----------
  if (!cleaned) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Phone number is required*",
    }));
  } 
  else if (countryCode === "+1 (US)" && cleaned.length !== 10) {
    setErrors((prev) => ({
      ...prev,
      [name]: "US/Canada phone number must be 10 digits",
    }));
  } 
  else if (countryCode === "+61 (AU)" && cleaned.length !== 10) {
    setErrors((prev) => ({
      ...prev,
      [name]: "Australian phone number must be 10 digits",
    }));
  } 
  else {
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  }
};

  const addressLine1ChangeHandler = (e) => {
    const { name, value } = e.target;
    setAddressLine1(e.target.value);
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const addressLine2ChangeHandler = (e) => {
    setAddressLine2(e.target.value);
  };

  const cityChangeHandler = (e) => {
    const { name, value } = e.target;
    setCity(e.target.value);
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const stateChangeHandler = (e) => {
    setState(e.target.value);
  };

  // const zipChangeHandler = (e) => {
  //   const { name, value } = e.target;
  //   const cleaned = value.replace(/[^0-9+\-\(\) ]/g, "");
  //   const digitsOnly = cleaned.replace(/[^0-9]/g, "");

  //   // Limit to 6 digits
  //   if (digitsOnly.length <= 5) {
  //     setZip(cleaned);
  //   }

  //   if (!value.trim()) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
  //     }));
  //   } else if (digitsOnly.length < 5) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: "Invalid Zip",
  //     }));
  //   } else {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: "",
  //     }));
  //   }
  // };

// const zipChangeHandler = (e) => {
//   const { name, value } = e.target;
//   const cleaned = value.replace(/[^0-9A-Za-z]/g, "");
//   const digitsOnly = cleaned.replace(/[^0-9]/g, "");
//   const alnumOnly = cleaned; 
//   const containsLetter = /[A-Za-z]/.test(alnumOnly);

//   if (containsLetter) {
//     const capped = alnumOnly.slice(0, 6).toUpperCase();
//     setZip(capped);
//   } else {
//     const cappedDigits = digitsOnly.slice(0, 5);
//     setZip(cappedDigits);
//   }

//   if (!value.trim()) {
//     setErrors((prev) => ({
//       ...prev,
//       [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
//     }));
//     return;
//   }

//   if (containsLetter) {
//     if (alnumOnly.length < 5 || alnumOnly.length > 7) {
//       setErrors((prev) => ({ ...prev, [name]: "Invalid Zip/Postal Code" }));
//     } else {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   } else {
//     if (digitsOnly.length < 5) {
//       setErrors((prev) => ({ ...prev, [name]: "Invalid Zip/Postal Code" }));
//     } else {
//       setErrors((prev) => ({ ...prev, [name]: "" }));
//     }
//   }
// };

const zipChangeHandler = (e) => {
  const { name, value } = e.target;

  const cleaned = value.replace(/[^0-9A-Za-z]/g, "");
  const digitsOnly = cleaned.replace(/[^0-9]/g, "");
  const alnumOnly = cleaned;
  const containsLetter = /[A-Za-z]/.test(alnumOnly);

  if (containsLetter) {
 
    const capped = alnumOnly.slice(0, 6).toUpperCase();
    setZip(capped);
  } else {
  
    const cappedDigits = digitsOnly.slice(0, 5);
    setZip(cappedDigits);
  }

  if (!value.trim()) {
    setErrors((prev) => ({
      ...prev,
      [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
    }));
    return;
  }

  if (containsLetter) {
    if (alnumOnly.length !== 6) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Invalid Zip/Postal Code",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  } else {
    // Australia (4) OR USA (5)
    if (digitsOnly.length !== 4 && digitsOnly.length !== 5) {
      setErrors((prev) => ({
        ...prev,
        [name]: "Invalid Zip/Postal Code",
      }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  }
};

  
const formatPhoneForPayload = (phone) => {

  let cleaned = phone.replace(/\D/g, "");
  if (cleaned.length === 10) {
    cleaned = cleaned;
  }
  return cleaned;
};

  const saveUserHandler = async () => {
    if (
      String(password).toLowerCase().replace(" ", "") !==
      String(confirmPassword).toLowerCase().replace(" ", "")
    ) {
      return toast.error("Password do not match, Sign-up failed..!", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
    } else if (
      !email ||
      !firstName ||
      !lastName ||
      !password ||
      !confirmPassword ||
      !companyName ||
      !phoneNumber ||
      !addressLine1 ||
      !city ||
      !state ||
      !zip
    ) {
      return toast.error("Sign-up Failed, Please fill all fields", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
    } else if (
      errors.Email ||
      errors.FirstName ||
      errors.LastName ||
      errors.Password ||
      errors.ConfirmPassword ||
      errors.CompanyName ||
      errors.PhoneNumber ||
      errors.AddressLine1 ||
      errors.City ||
      errors.Zip
    ) {
      return toast.error("Sign-up Failed, Please enter valid information.", {
        duration: 6000,
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: is4kScreen
                ? "1.9rem"
                : isXxlScreen
                ? "1.6rem"
                : isXlScreen
                ? "1.5rem"
                : isIpadProPortrait
                ? "1.8rem"
                : isLargeScreen
                ? "0.9rem"
                : isMediumScreen
                ? "1.4rem"
                : "1rem",
            }}
            icon={faCircleExclamation}
          />
        ),
        style: {
          backgroundColor: "#FFC1B4",
          color: "red",
          fontSize: is4kScreen
            ? "1.9rem"
            : isXxlScreen
            ? "1.15rem"
            : isXlScreen
            ? "1rem"
            : isIpadProPortrait
            ? "1.8rem"
            : isLargeScreen
            ? "1rem"
            : isMediumScreen
            ? "1.1rem"
            : "1rem",
          marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
        },
      });
    }

    const cleanedPhoneNumber = formatPhoneForPayload(phoneNumber);
    const data = {
      customerId: Number(CUSTOMERID),
      companyName: companyName,
      email: email,
      password: password,
      firstName: firstName,
      lastName: lastName,
      phone1: cleanedPhoneNumber,
      streetAddress1: addressLine1,
      streetAddress2: addressLine2,
      city: city,
      state: state,
      zipCode: zip,
      status: "Active",
    };
    const { streetAddress2, ...mandatoryData } = data;
    if (Object.values(mandatoryData).includes("")) {
      return;
    }
    // let formData = new FormData();
    // Object.entries(data).map(([key, value]) => {
    //   formData.append(key, value);
    // });
    // console.log("form data", formData);
    try {
      setLoading(!loading);
      const res = await fetch(`${REGISTER_USER}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`, // Add your token here
        },
      });

      const result = await res.json();

      if (res.status === 400) {
        return toast.error(result.message, {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
      } else if (result) {
        toast.success("Sign-up successful, Please login to continue", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                color: "green",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleCheck}
            />
          ),
          style: {
            backgroundColor: "#E7EFC7",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
        navigate("/login");
        setErrMsg("");
      }
    } catch (e) {
      // toast.error(
      //   "Failed to Signup, Please enter all mandatory fields correctly"
      // );
      console.log(e);
      setErrMsg(
        "Failed to Signup, Please enter all mandatory fields correctly"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setState(states[0]);
  }, []);

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [name]: `${name.replace(/([A-Z])/g, " $1")} is required*`,
      }));
    }
  };

  return (
    <>
      <Container
        style={{
          marginBottom: is4kScreen ? "4rem" : "2em",
          marginTop: is4kScreen
            ? "11em"
            : isIpadProPortrait
            ? "8rem"
            : isLargeScreen
            ? "6rem"
            : isMediumScreen
            ? "6rem"
            : "7rem",
          height: "100%",
          minHeight: "85vh",
          width: isMediumScreen
            ? "90%"
            : isIpadProPortrait
            ? "90%"
            : isLargeScreen
            ? "60%"
            : "",
        }}
        className="postion-relative col-sm-12 w-60% col-md-6"
      >
        <Card
          className=""
          style={{ boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)" }}
        >
          <Card.Body>
            <Row>
              <Col md={12}>
                <p
                  style={{
                    textAlign: "center",
                    fontSize: is4kScreen
                      ? "3rem"
                      : isXxlScreen
                      ? "2.1rem"
                      : isXlScreen
                      ? "2rem"
                      : isIpadProPortrait
                      ? "2.1rem"
                      : isLargeScreen
                      ? "2rem"
                      : isMediumScreen
                      ? "1.6rem"
                      : "1.2rem",
                  }}
                  className="login-heading" 
                >
                  Sign Up
                </p>
                <Row className="mb-1">
                  <Col className="cust-card mb-2">
                    <div style={{ padding: "0px 2em" }} className="sign-up">
                      <SubTitle text="Login Information" />
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicEmail"
                      >
                        <lable
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            // fontSize: is4kScreen
                            //   ? "2rem"
                            //   : isXxlScreen
                            //   ? " 1.2rem"
                            //   : isXlScreen
                            //   ? "1.05rem"
                            //   : isLargeScreen
                            //   ? "1rem"
                            //   : "1rem",
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Email address:<span style={{ color: "red" }}>*</span>
                        </lable>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-12 col-sm-6 col-md-8  form-control"
                            // style={{
                            //   height: is4kScreen
                            //     ? "4.5rem"
                            //     : isIpadProPortrait
                            //     ? "3.8rem"
                            //     : isMediumScreen
                            //     ? "3.8rem"
                            //     : "3rem",
                            //   fontSize: is4kScreen
                            //     ? "2rem"
                            //     : isXxlScreen
                            //     ? ""
                            //     : isXlScreen
                            //     ? ""
                            //     : isIpadProPortrait
                            //     ? "1.6rem"
                            //     : isLargeScreen
                            //     ? "1rem"
                            //     : isMediumScreen
                            //     ? "1.4rem"
                            //     : "",
                            // }}
                            type="email"
                            name="Email"
                            disabled={loading}
                            value={email}
                            onChange={(e) => emailChangeHandler(e)}
                            onBlur={handleBlur}
                            required
                          />{" "}
                          {errors.Email && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.Email}
                            </span>
                          )}
                          {/* {email && !validator.isEmail(email) ? (
                            <span style={{ color: "red" }}>
                              Enter a valid email
                            </span>
                          ) : (
                            <></>
                          )} */}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicPassword"
                      >
                        <lable
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Password:<span style={{ color: "red" }}>*</span>
                        </lable>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8  form-control"
                            type="password"
                            name="Password"
                            disabled={loading}
                            value={password}
                            onChange={(e) => passwordChangeHandler(e)}
                            onBlur={handleBlur}
                            required
                          />
                          {errors.Password && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.Password}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="mb-2 row row d-flex justify-content-center align-items-center"
                        controlId="formBasicConfirmPassword"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Confirm Password:
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="password"
                            name="ConfirmPassword"
                            disabled={loading}
                            value={confirmPassword}
                            onChange={(e) => confirmPasswordHandler(e)}
                            onBlur={handleBlur}
                            required
                          />
                          {errors.ConfirmPassword && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.ConfirmPassword}
                            </span>
                          )}
                          {/* {password &&
                          confirmPassword &&
                          String(password).toLowerCase().replace(" ", "") !==
                            String(confirmPassword)
                              .toLowerCase()
                              .replace(" ", "") ? (
                            <span style={{ color: "red" }}>
                              Password must match
                            </span>
                          ) : (
                            <></>
                          )} */}
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: is4kScreen
                            ? "3rem"
                            : isXxlScreen
                            ? "2.5rem"
                            : isXlScreen
                            ? "2rem"
                            : isIpadProPortrait
                            ? "2rem"
                            : isLargeScreen
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.7rem"
                            : "",
                        }}
                      >
                        <SubTitle
                          text="Contact Information"
                          className="text-center"
                        />
                      </div>

                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicName"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          First Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="FirstName"
                            disabled={loading}
                            value={firstName}
                            onChange={(e) => firstNameChangeHandler(e)}
                            onBlur={handleBlur}
                            required
                          />
                          {errors.FirstName && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.FirstName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicLast"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Last Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="LastName"
                            disabled={loading}
                            value={lastName}
                            onChange={(e) => lastNameChangeHandler(e)}
                            onBlur={handleBlur}
                            required
                          />
                          {errors.LastName && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.LastName}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicCompany"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Company Name:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="CompanyName"
                            disabled={loading}
                            value={companyName}
                            onChange={(e) => companyNameChangeHandler(e)}
                            onBlur={handleBlur}
                          />
                          {errors.CompanyName && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.CompanyName}
                            </span>
                          )}
                        </div>
                      </div>
                     <div
  className="mb-3 row d-flex justify-content-center align-items-center"
>
  <label
    className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
    style={{
      fontSize: is4kScreen
        ? "2rem"
        : isXxlScreen
        ? "1.25rem"
        : isXlScreen
        ? "1.05rem"
        : isIpadProPortrait
        ? "1.8rem"
        : isLargeScreen
        ? "1rem"
        : isMediumScreen
        ? "1.3rem"
        : "1rem",
    }}
  >
    Phone Number:<span style={{ color: "red" }}>*</span>
  </label>

  <div className="col-sm-8 col-md-8 col-12">
    <div className="phone-input-wrapper">
      <select
        className="country-code-select"
        value={countryCode}
        onChange={(e) => setCountryCode(e.target.value)}
        disabled={loading}
      >
        <option value="+1 (US)">+1 (US)</option>
        <option value="+1 (CA)">+1 (CA)</option>
        <option value="+61 (AU)">+61 (AU)</option>
      </select>

      <input
        type="text"
        className="form-control phone-input"
        name="PhoneNumber"
        disabled={loading}
        value={phoneNumber}
        onChange={phoneNumberChangeHandler}
        maxLength={countryCode === "+61 (AU)" ? 12 : 14}
        onBlur={handleBlur}
      />
    </div>

    {errors.PhoneNumber && (
      <span style={{ color: "red" }}>
        {errors.PhoneNumber}
      </span>
    )}
  </div>
</div>

                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicLast"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Address Line 1:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="AddressLine1"
                            disabled={loading}
                            value={addressLine1}
                            onChange={(e) => addressLine1ChangeHandler(e)}
                            onBlur={handleBlur}
                          />
                          {errors.AddressLine1 && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.AddressLine1}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicCompany"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Address Line 2:
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            disabled={loading}
                            value={addressLine2}
                            onChange={(e) => addressLine2ChangeHandler(e)}
                          />
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicName"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Suburb/City:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="City"
                            disabled={loading}
                            value={city}
                            onChange={(e) => cityChangeHandler(e)}
                            onBlur={handleBlur}
                          />
                          {errors.City && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.City}
                            </span>
                          )}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicLast"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          State/Province:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12 sign-up">
                          <select
                            className="form-select"
                            disabled={loading}
                            value={state}
                            onChange={stateChangeHandler}
                            aria-label="Default select example"
                            style={{
                              height: is4kScreen
                                ? "70px"
                                : isIpadProPortrait
                                ? "70px "
                                : "",
                              fontSize: is4kScreen
                                ? "1.7rem"
                                : isXxlScreen
                                ? "1.2rem"
                                : isIpadProPortrait
                                ? "1.8rem"
                                : isMediumScreen
                                ? "1.1rem"
                                : "",
                              color: "#000",
                            }}
                            required
                          >
                            
                      {states.map((state, ind) => {
                              return (
                                <option
                                  value={state}
                                  style={{
                                    fontSize: isIpadProPortrait
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1rem"
                                      : "",
                                    color: "#000",
                                  }}
                                >
                                  {state}
                                </option>
                              );
                            })}
                          </select>
                          {validation && <p>This filed is required*</p>}
                          {/* <input
                            className="col-md-8 form-control"
                            type="text"
                            disabled={loading}
                            value={state}
                            onChange={(e) => stateChangeHandler(e)}
                          /> */}
                        </div>
                      </div>
                      <div
                        className="mb-3 row d-flex justify-content-center align-items-center"
                        controlId="formBasicCompany"
                      >
                        <label
                          className="col-sm-4 col-md-4 col-12 text-md-center text-start form-label"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? "1.25rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : isSmallScreen
                              ? ""
                              : "1rem",
                          }}
                        >
                          Zip/Postcode:<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="col-sm-8 col-md-8 col-12">
                          <input
                            className="col-md-8 form-control"
                            type="text"
                            name="Zip"
                            disabled={loading}
                            value={zip}
                            onChange={(e) => zipChangeHandler(e)}
                            onBlur={handleBlur}
                            maxLength={countryCode === "+61 (AU)" ? 4 : countryCode === "+1 (US)"? 5 : countryCode === "+1 (CA)" ? 6 : 6}
                          />
                          {errors.Zip && (
                            <span
                              style={{
                                color: "red",
                                fontSize: is4kScreen
                                  ? "1.5rem"
                                  : isIpadProPortrait
                                  ? "1.6rem"
                                  : isMediumScreen
                                  ? "1.13rem"
                                  : "",
                              }}
                            >
                              {errors.Zip}
                            </span>
                          )}
                        </div>
                      </div>

                      {errMsg !== "" && (
                        <span style={{ color: "red" }}>{errMsg}</span>
                      )}

                      <div
                        className="d-flex recaptcha-wrapper  justify-content-center align-items-center pt-1 pb-3"
                        style={{
                          marginLeft: isIpadProPortrait
                            ? ""
                            : isLargeScreen
                            ? "5rem"
                            : isXlScreen
                            ? "5rem"
                            : isXxlScreen
                            ? "4rem"
                            : isMediumScreen
                            ? "5rem"
                            : "",
                          marginRight: isMediumScreen ? "10rem" : "",
                        }}
                      >
                        <ReCAPTCHA
                          className="responsive-recaptcha"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isLargeScreen
                              ? "1.5rem"
                              : "30px",
                          }}
                          sitekey={siteKey}
                          onChange={onChange}
                        ></ReCAPTCHA>
                      </div>
                      <div className="d-flex justify-content-center align-items-center">
                        <Button
                          disabled={!recaptchaValue}
                          onClick={saveUserHandler}
                          className="login-btns btn mb-3"
                          type="submit"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXxlScreen
                              ? " 1.2rem"
                              : isXlScreen
                              ? "1.05rem"
                              : isIpadProPortrait
                              ? "1.8rem"
                              : isLargeScreen
                              ? "1.1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : "1rem",
                          }}
                        >
                          <Loader response={loading} action={"Sign up"} />
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default Signup;
